import classnames from 'classnames';

import { CmsResourcesSection } from '@interfaces/common';

import { Resource } from './Resource';
import styles from './ResourcesSection.module.css';

export type ResourcesSectionProps = Omit<CmsResourcesSection, '_key' | '_type'>;

export const ResourcesSection: React.VFC<ResourcesSectionProps> = ({
	paragraph,
	source,
	resources,
}) => {
	return (
		<section className={styles.details}>
			<div className={styles.container}>
				<p className={classnames(styles['big-paragraph'], 'fluid-font-t2')}>
					{paragraph}
				</p>
				<ul className={classnames(styles.advantages, 'stack-block')}>
					{resources.map(({ _key, ...resource }) => (
						<li key={_key}>
							<Resource {...resource} />
						</li>
					))}
				</ul>
				<small className={styles.source}>{source}</small>
			</div>
		</section>
	);
};
